<template>
    <div class="row">
        <div class="col-md-12">
            <h3 class="text-center">{{ "Edition du texte «" + currentText.content + "»" }}</h3>
            <div class="form-group">
                <label>Texte : </label>
                <bsInput type="text" v-model.lazy="text"></bsInput>
            </div>
            <div class="form-group">
                <label>Prononciation : </label>
                <bsInput type="text" v-model.lazy="pronunciation"></bsInput>
            </div>
        </div>
        <div class="col-md-12 text-right">
            <button v-if="currentText.pronunciation != currentText.content" class="btn btn-primary btn-sm pull-left" type="button" @click="currentText.pronunciation = currentText.content">Réinitialiser la prononciation</button>
            <button class="btn btn-info btn-sm" type="button" @click="save">Sauvegarder</button>
            <!-- <button class="btn btn-info btn-sm" type="button" @click="save(false)">Sauvegarder sans mettre à jour le recordId</button> -->
        </div>
    </div>
</template>

<script>
    import { input as BsInput }  from 'vue-strap'

    export default {
        components: {
            BsInput
        },
        computed: {
            currentText: function() {
                return this.$store.state.admin.currentText;
            },
            formMode: function() {
                return this.$route.meta.mode;
            },
            text: {
                get() {
                    return this.currentText.content;
                },
                set(value) {
                    this.$store.commit('CURRENT_TEXT_UPDATED', {key: 'content', data: value});
                }
            },
            pronunciation: {
                get() {
                    return this.currentText.pronunciation || this.currentText.content;
                },
                set(value) {
                    this.$store.commit('CURRENT_TEXT_UPDATED', {key: 'pronunciation', data: value});
                }
            }
        },
        methods: {
            save(updateRecordId = true)  {
                let textPatch = this.formMode == 'create' ? 'créé' : 'mis à jour';
                let successCallback = (id) => {
                    this.$router.push({ name: 'PersonDetail', params: { themeId: this.$route.params.themeId, personId: this.$route.params.personId }});
                    this.$store.commit('ALERT_DATA_UPDATED', {
                        text: 'Le texte a été mis à jour avec succès.',
                        type: 'success'
                    });
                };

                this.$store.dispatch('updateText', {
                    newText: this.currentText,
                    updateRecordId: updateRecordId,
                    callbacks: { success: successCallback }
                });
            }
        },
        data: function()  {
            return {
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux textes',
                pathData: {
                    name: "PersonDetail",
                    params: {
                        themeId: this.$route.params.themeId,
                        personId: this.$route.params.personId
                    }
                }
            });
        }
    };
</script>
